import { LOGIN, LOGOUT, SET_USER, SET_USER_TYPE } from '../actions'

const AppReducer = (state, action) => {
    switch (action.type) {
        case LOGIN:
            return { ...state, isLoggedIn: true }
        case LOGOUT:
            return { ...state, isLoggedIn: false }
        case SET_USER:
            return { ...state, user: { ...action.payload } }
        case SET_USER_TYPE:
            return { ...state, type: action.payload }

        default:
            return { ...state }
    }
}

export default AppReducer